import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "../lib/api";

const LABELS = { story_week_waitlist: "Story Week waitlist", founding_beta: "Founding beta" };

export const HoldingSignups = () => {
  const [summary, setSummary] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/holding/waitlist/summary").then((r) => setSummary(r.data)).catch(() => setErr("Couldn't load holding-page sign-ups."));
  }, []);

  const download = async () => {
    setBusy(true);
    setErr("");
    try {
      const res = await api.get("/holding/waitlist.csv", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `holding-waitlist-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      setErr("Download failed. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mb-10 p-6 bg-white hairline-cream flex flex-col sm:flex-row sm:items-center gap-5" style={{ borderRadius: 4 }} data-testid="holding-signups">
      <div className="flex-1">
        <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.25em]">HOLDING PAGE SIGN-UPS</p>
        <p className="mt-2 text-3xl text-[#111D33]" style={{ fontFamily: "Cormorant Garamond, serif" }} data-testid="holding-signups-total">
          {summary ? summary.total : "…"}
        </p>
        {summary && (
          <p className="mt-1 text-sm text-[#8C8278]" style={{ fontFamily: "Georgia, serif" }} data-testid="holding-signups-breakdown">
            {Object.keys(LABELS).map((k) => `${LABELS[k]}: ${summary.by_source[k] || 0}`).join(" · ")}
          </p>
        )}
        {err && <p className="mt-2 text-sm text-[#8A1F1F]" role="alert" data-testid="holding-signups-error">{err}</p>}
      </div>
      <button
        type="button"
        onClick={download}
        disabled={busy}
        className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#5a2433] text-[#f6f1e8] hover:bg-[#451b27] transition-colors disabled:opacity-50"
        style={{ borderRadius: 999, fontFamily: "Georgia, serif", fontSize: "15px", minHeight: 48 }}
        data-testid="holding-signups-download-btn"
      >
        <Download size={16} aria-hidden="true" />
        {busy ? "Preparing…" : "Download waitlist CSV"}
      </button>
    </section>
  );
};
